import { useMutation } from "react-query";
import { axiosInstance } from "../../../../utils/axiosInstance";
import { message } from "antd";
import { useGetTutorQuery } from "./useGetTutorQuery";

export const useSendVerifyOTPMutation = () => {
  const { data: tutor } = useGetTutorQuery();

  const id = tutor?.data?.id;
  const token = localStorage.getItem("W2ST_TUTOR_TOKEN");

  return useMutation(
    () =>
      axiosInstance
        .post(
          `tutors/send-otp/${id}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((res: any) => res.data),
    {
      onSuccess: async () => {
        message.success("OTP sent successfully.");
      },
      onError: (error: any) => {
        message.error(
          error?.response?.data?.message ||
            "Failed to send OTP. Please try again."
        );
      },
    }
  );
};
